import React, { useEffect, useState } from 'react';
import QuizItemAnswerContent from './QuizItemAnswerContent';
import { useModal } from '../../../../hooks/useModal';
import { nyTaskContent } from '../../../../constants/copyright';

const { afterAnswerModal } = nyTaskContent;

const QuizItemAnswer = React.forwardRef(function QuizItemAnswer(
  { text, isNY, image, note, answers, nextStep, setScore, buttonId, setButtonId, note_image, note_title, ...rest },
  ref,
) {
  const [answerId, setAnswerId] = useState();
  const { addModal } = useModal();

  const answerClick = (id) => {
    setAnswerId(id);
  };

  useEffect(() => {
    if (typeof answerId !== 'number') return;
    let locked = false; // для блокировки возможности кликов
    const successCallback = () => {
      if (locked) return;
      locked = true;
      nextStep();
      setScore(answerId);
      setTimeout(() => {
        locked = false;
      }, 300);
    };

    addModal({
      type: 'quizStartModal',
      props: {
        ...afterAnswerModal,
        image: note_image,
        title: note_title,
        description: note,
        goToQuiz: successCallback,
        onClose: undefined,
      },
    });
  }, [answerId]);

  return (
    <div className={'quiz__item quiz__item_answer'} ref={ref}>
      <div className={'quiz__item-block'}>
        <QuizItemAnswerContent
          answerClick={answerClick}
          text={text}
          note={note}
          answers={answers}
          buttonId={buttonId}
          setButtonId={setButtonId}
          image={isNY && image}
        />
      </div>
    </div>
  );
});

export default QuizItemAnswer;
QuizItemAnswer.propTypes = {};
